import { Component, Input } from '@angular/core'

@Component({
  selector: 'lin-dashboard-card',
  template: `
    <div class="title">
      <span class="h2">{{ title }}</span>
      @if (routerLink) {
        &nbsp;<a [routerLink]="routerLink" class="view-more">{{ 'CLIENT.VEHICLES.VIEW_MORE' | translate }}</a>
      }
    </div>
    <div class="content"><ng-content></ng-content></div>
  `,
  styleUrls: [`./dashboard-card.component.scss`],
  standalone: false,
})
export class DashboardCardComponent {
  @Input() title: string
  @Input() routerLink: string | any[]
}
